<template>
  <div class="py-3 bg-transparent">
    <div class="notification-header mb-8">
      <div class="flex items-center justify-start gap-8">
        <span
          class="cursor-pointer notification__inactive"
          :class="{
            notification__active: notificationType === 'learning-actions',
          }"
          id="learning-actions"
          @click="notificationType = 'learning-actions'"
          v-if="appSubscriptions.alex"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">{{ $t('orgDashboard.userDashboard.notifications.learningActions') }}</h4>
        </span>
        <span
          v-if="appSubscriptions.journey && galaQuests"
          class="cursor-pointer notification__inactive"
          :class="{
            notification__active: notificationType === 'journey-quests',
          }"
          id="journey-quests"
          @click="notificationType = 'journey-quests'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">Journey Quests</h4>
        </span>

        <!-- New Invites Tab -->
        <span
          class="cursor-pointer notification__inactive"
          :class="{ notification__active: notificationType === 'invites' }"
          id="invites"
          @click="notificationType = 'invites'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">{{ $t('orgDashboard.userDashboard.notifications.invites') }}</h4>
        </span>

        <!-- Growth Plans Tab - Commented Out -->
        <!-- <span
          v-if="appSubscriptions.coach"
          class="cursor-pointer notification__inactive"
          :class="{ notification__active: notificationType === 'growth-plans' }"
          id="growth-plans"
          @click="notificationType = 'growth-plans'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">Growth Plans</h4>
        </span> -->
      </div>
    </div>

    <div class="notification__container w-full h-full mt-4">
      <div v-if="loadingSkeleton" class="">
        <vs-row class="px-3 py-3">
          <vs-row
            v-for="i in 5"
            :key="i"
            class="p-16 rounded-lg my-2 bg-slate-300 animate-pulse"
          />
        </vs-row>
      </div>

      <div v-if="!loadingSkeleton" class="rounded-lg overflow-hidden">
        <div
          v-if="
            notificationType === 'learning-actions' && appSubscriptions.alex
          "
        >
          <!-- validation notification content... (Unchanged) -->
          <div
            v-if="items && items.length > 0 && !loadingSkeleton"
            class="flex flex-col gap-1"
          >
            <!-- ... existing items loop ... -->
             <div
              v-for="(item, index) in items"
              :key="item.itemId"
              :id="item.itemId"
              style="display: flex"
              class="items-center justify-between w-full bg-white py-6 px-4"
              :class="{
                hidden: !(
                  (item.status === 'done' ||
                    item.feedLibraryItemStatus === 'done') &&
                  item.libraryItemValidationData
                ),
              }"
            >
              <div class="flex w-full gap-4">
                <div class="w-24 h-24 overflow-hidden rounded-lg">
                  <img
                    class="w-full h-full object-cover"
                    :src="item.imageUrl"
                    @error="randomFeedImage"
                  />
                </div>
                <div class="flex flex-col gap-4 w-full justify-between">
                  <div class="flex flex-row w-full gap-2">
                    <h5 class="flex text-left w-full text-lg">
                      {{ item.title | title }}
                    </h5>

                    <vs-dropdown
                      vs-trigger-click
                      class="w-fit h-fit cursor-pointer"
                    >
                      <div class="w-6 h-6 relative">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_735_19)">
                            <path
                              d="M12 17C12.5304 17 13.0391 17.2107 13.4142 17.5858C13.7893 17.9609 14 18.4696 14 19C14 19.5304 13.7893 20.0391 13.4142 20.4142C13.0391 20.7893 12.5304 21 12 21C11.4696 21 10.9609 20.7893 10.5858 20.4142C10.2107 20.0391 10 19.5304 10 19C10 18.4696 10.2107 17.9609 10.5858 17.5858C10.9609 17.2107 11.4696 17 12 17ZM12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10ZM12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5C14 5.53043 13.7893 6.03914 13.4142 6.41421C13.0391 6.78929 12.5304 7 12 7C11.4696 7 10.9609 6.78929 10.5858 6.41421C10.2107 6.03914 10 5.53043 10 5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3Z"
                              fill="#737171"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_735_19">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>

                      <vs-dropdown-menu class="ml-2 mt-2">
                        <div class="bg-white flex flex-col rounded">
                          <div
                            class="text-black flex-row items-center gap-2 hover:bg-slate-100 p-2 cursor-pointer"
                            @click="skipValidation(item)"
                          >
                            <p>Skip Validation</p>
                          </div>
                        </div>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                  <div class="w-full mt-0 flex items-center justify-between">
                    <div ref="itemOptions" class="flex items-center">
                      <div
                        class="flex items-center gap-4"
                        v-for="(token, i) in item.libraryItemValidationData
                          .tokens"
                        :key="i"
                      >
                        <!-- gold-coin -->
                        <div
                          v-if="token.label === 'Gold'"
                          class="flex items-end p-2 rounded-lg gap-1"
                          :id="
                            activeIndex === index
                              ? `${item.libraryItemValidationData.gtbrddOrganizationId.slice(
                                  -5
                                )}-reward-gold`
                              : ''
                          "
                        >
                          <img
                            class="w-8 h-8"
                            src="@/assets/images/icons/tokens/gold-coin.svg"
                            alt=""
                          />
                          <h6 class="text-base">
                            {{ token.value }}
                          </h6>
                        </div>

                        <!-- xp -->
                        <div
                          v-if="token.label === 'XPs'"
                          class="flex items-end p-2 rounded-lg gap-1"
                          :id="activeIndex === index ? 'reward-xp' : ''"
                        >
                          <img
                            class="w-8 h-8"
                            src="@/assets/images/icons/tokens/xp.svg"
                            alt=""
                          />

                          <h6 class="text-base">
                            {{ token.value }}
                          </h6>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div
                        v-if="
                          item.reviewStatus &&
                          item.reviewStatus.toLowerCase() === 'accepted'
                        "
                        @click="claimReward(item, index)"
                        class="btn-claim text-xl font-medium rounded-lg py-2 px-4 cursor-pointer ml-2"
                      >
                        {{ item.tokenClaimed ? "Claimed" : "Claim" }}
                      </div>
                      <div
                        v-else-if="item.feedItemUserValidationStatus === false"
                        @click="validateItem(item)"
                        class="text-black ml-2 btn-validate text-lg font-semibold rounded-lg py-2 px-4 cursor-pointer"
                      >
                        Validate
                      </div>
                      <div v-else>
                        <vs-tooltip
                          text="Waiting for admin approval"
                          position="top"
                        >
                          <feather-icon
                            class="cursor-pointer"
                            style="color: #fb2e56"
                            icon="ClockIcon"
                            svgClasses="h-6 w-6"
                          />
                        </vs-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="flex flex-col p-4 gap-8 items-center w-full h-full justify-center py-8"
            v-if="!loadingSkeleton && items.length === 0"
          >
            <img
              class="lg:w-4/12 w-64"
              src="@/assets/images/temp-img/empty-notification.svg"
            />
            <div class="flex flex-col gap-6 justify-center items-center">
              <p class="text-lg text-center font-semibold flex gap-2 flex-col">
                {{ $t('orgDashboard.userDashboard.notifications.noNotifications') }}
              </p>
            </div>
          </div>
        </div>

        <div
          v-if="
            notificationType === 'journey-quests' && appSubscriptions.journey
          "
          class="bg-white p-4 rounded-lg"
        >
          <!-- journey quests content... (Unchanged) -->
           <div class="progress__container mt mb-4">
            <div class="progress__container__info">
              <img src="@/assets/images/icons/progress-coin.svg" />
              <span v-if="journeyIndex === 1"> {{ completedSteps * 100 }}</span>
              <span v-if="journeyIndex === 2">{{ completedSteps * 200 }}</span>
            </div>
            <div class="progress__container__bar">
              <vs-tooltip
                v-for="(step, i) in activeStep"
                :text="getStepName(step.id)"
                :key="i"
                class="flex justify-center"
                :class="i % 2 === 0 ? 'odd' : 'even'"
                :position="i % 2 === 0 ? 'top' : 'bottom'"
              >
                <a :href="step.url" target="_blank">
                  <img
                    :key="i"
                    :class="i % 2 === 0 ? 'odd' : 'even'"
                    :src="
                      require(`@/assets/images/icons/chest-${
                        i % 2 === 0 ? 'top' : 'bottom'
                      }.svg`)
                    "
                    :alt="step.id"
                  />
                </a>
              </vs-tooltip>

              <progress
                v-if="activeStep"
                class="progress"
                max="100"
                :value="getJourneyProgress(activeStep)"
              ></progress>
            </div>
          </div>
          <vs-row
            class="journey__notification__card cursor-pointer p-4 mb-3"
            v-for="(journeyQuest, i) in journeyQuests"
            :key="i"
            :class="`q${journeyIndex}` === i ? '' : 'opacity-50'"
          >
            <div class="w-full" @click="activeSelectedStep(journeyQuest, i)">
              <h4 class="flex text-white text-left font-semibold mb-4">
                Gala Quest {{ i === "q1" ? 1 : 2 }}
                <a
                  class="ml-3"
                  :href="journeyQuest.steps[1].url"
                  target="_blank"
                >
                  <img
                    src="@/assets/images/icons/arrow-right-circle-white.svg"
                    alt=""
                    class="w-6 h-6"
                  />
                </a>
              </h4>
              <progress
                class="progress w-full"
                max="100"
                :value="getJourneyProgress(journeyQuest.steps)"
              />

              <div
                class="flex items-start mt-8 w-full justify-between"
              >
                <h5 class="text-left text-white w-1/2">
                  Activated since <br />
                  <span class="font-semibold">
                    {{ getGoalActiveDate(i) }}
                    {{ i === "q1" ? questQ1 : questQ2 }}
                  </span>
                </h5>
                <div class="reward__container flex py-2 px-1">
                  <!-- gold-coin -->
                  <div
                    class="token-box flex items-center justify-center py-1 px-2 mx-1"
                  >
                    <img
                      class="w-6 h-6"
                      src="@/assets/images/icons/tokens/gold-coin.svg"
                      alt=""
                    />
                    <h6 class="ml-1 text-xl" v-if="i === 'q1'">500</h6>
                    <h6 class="ml-1 text-xl" v-if="i === 'q2'">500</h6>
                  </div>
                  <!-- xp -->
                  <div
                    class="token-box flex items-center justify-center p-2 mx-1"
                  >
                    <img
                      class="w-6 h-6"
                      src="@/assets/images/icons/tokens/xp.svg"
                      alt=""
                    />

                    <h6 class="ml-1 text-xl" v-if="i === 'q1'">5000</h6>
                    <h6 class="ml-1 text-xl" v-if="i === 'q2'">5000</h6>
                  </div>
                </div>
              </div>
            </div>
          </vs-row>
        </div>

        <!-- NEW Invites Tab Content -->
        <div v-if="notificationType === 'invites'" class="p-4">
  <div class="vx-row" v-if="myOrganizations && (myOrganizations.superOrgs.length > 0 || myOrganizations.subOrgs.length > 0)">
    <!-- Super Orgs / Owned Orgs -->
    <div v-for="(myOrgs, index) in myOrganizations.superOrgs" :key="'superOrg-' + index"
      class="vx-col w-full lg:w-1/3 xl:w-1/3 mb-base" :class="myOrgs.status === 'DEACTIVATED' ? 'hidden' : ''">
      <vx-card v-if="myOrgs.status !== 'DEACTIVATED'" class="org-card overflow-hidden">
        <div class="items-center flex flex-col justify-between" style="min-height: 360px">
          <div>
            <vs-avatar v-if="myOrgs.logo" class="my-4 profile-picture" size="160px" :src="constants.s3Bucket + '/organization/logo/' + myOrgs.logo" />
            <vs-avatar v-else class="my-4 profile-picture" size="160px" :src="require('@/assets/images/icons/organization/business_black_36dp.svg')" />
            <div class="mb-base"><h2 class="mb-1">{{ myOrgs.name }}</h2><p>{{ myOrgs.website }}</p></div>
          </div>
          <vs-button class="mb-base" size="large" color="primary" type="filled" @click.stop="manageOrganization(myOrgs.slug || myOrgs._id)">{{ $t('orgDashboard.userDashboard.notifications.manage') }}</vs-button>
        </div>
      </vx-card>
    </div>

    <!-- Sub Orgs / Invited Orgs -->
    <div v-for="(myOrgs, index) in myOrganizations.subOrgs" :key="'subOrg-' + index"
      class="vx-col w-full lg:w-1/3 xl:w-1/3 mb-base" :class="myOrgs.status === 'DEACTIVATED' ? 'hidden' : ''">
      <vx-card class="org-card overflow-hidden" v-if="myOrgs.status !== 'DEACTIVATED'">
        <div class="items-center flex flex-col justify-between" style="min-height: 360px">
          <div>
            <vs-avatar v-if="myOrgs.organization[0] && myOrgs.organization[0].logo" class="my-4 profile-picture" size="160px" :src="constants.s3Bucket + '/organization/logo/' + myOrgs.organization[0].logo" />
            <vs-avatar v-else class="my-4 profile-picture" size="160px" :src="require('@/assets/images/icons/organization/business_black_36dp.svg')" />
            <div class="mb-base"><h2 class="mb-1">{{ myOrgs.organization[0].name }}</h2><p>{{ myOrgs.organization[0].website }}</p></div>
          </div>
          <div v-if="myOrgs.status === 'active'">
            <vs-button class="mb-base" size="large" color="primary" type="filled" @click.stop="manageOrganization(myOrgs.organization[0].slug || myOrgs.organization[0]._id)">{{ $t('orgDashboard.userDashboard.notifications.manage') }}</vs-button>
          </div>
          <div v-else>
            <vs-button class="mb-base" size="large" color="success" type="filled" @click.stop="acceptAdminOrgInvite(myOrgs._id)">{{ $t('orgDashboard.userDashboard.notifications.acceptInvitation') }}</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>

  <!-- Empty State -->
  <div v-else class="flex flex-col p-4 gap-8 items-center w-full h-full justify-center py-8">
    <img class="lg:w-3/12 w-64" src="@/assets/images/temp-img/empty-organization.svg" />
    <div class="flex flex-col gap-6 justify-center items-center">
      <p class="text-xl text-black font-semibold text-center flex gap-2 flex-col">No Organization Found!</p>
      <router-link to="/organization/create" class="py-2 px-4 bg-primary text-slate-950 w-fit rounded-lg text-lg font-semibold">Create Organization</router-link>
    </div>
  </div>
</div>

        <!-- Growth Plans Content - Commented Out -->
        <!-- <div
          v-if="notificationType === 'growth-plans' && appSubscriptions.coach"
        >
          ... (Rest of the growth-plans logic remains here but will not render) ...
        </div> -->

        <div
          class="flex flex-col p-4 gap-8 items-center w-full h-full justify-center py-8"
          v-else-if="
            !appSubscriptions.coach &&
            !appSubscriptions.alex &&
            !appSubscriptions.journey &&
            notificationType !== 'invites'
          "
        >
          <img
            class="lg:w-3/12 w-64"
            src="@/assets/images/temp-img/empty-notification.svg"
          />
          <div class="flex flex-col gap-6 justify-center items-center">
            <p
              class="text-xl text-center flex gap-2 flex-col font-semibold text-black"
            >
              No notifications found!
              <br />
              <span class="font-normal text-slate-600 text-base"
                >Assign yourself tasks through your organization.</span
              >
            </p>
            <router-link
              to="/user/my-organizations"
              class="py-2 px-4 bg-primary text-slate-950 w-fit text-lg rounded-lg font-semibold"
              >Go to Organizations</router-link
            >
          </div>
        </div>
      </div>

      <div
        @click="claimAllRewards()"
        v-if="
          notificationType === 'learning-actions' &&
          !loadingSkeleton &&
          claimAllBtn &&
          items &&
          items.length > 0
        "
        class="sticky bottom-0 claim-all-btn p-4 flex justify-end"
      >
        <div
          class="max-w-max btn-claim-all text-lg font-medium rounded-lg py-2 px-4 cursor-pointer"
        >
          Read and Claim All
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import appSteps from "@/assets/data/app-flow";
import gsap from "gsap";
import constants from "@/constants.js";

export default {
  data() {
    return {
      notificationType: "",
      mergedItems: [],
      items: [],
      loadingSkeleton: true,
      coachUserData: {},
      growthPlan: [],
      selected: [],
      fill: { gradient: ["#4D927F", "#B7DA64"] },
      receivedCoachData: false,
      claimAllBtn: false,
      CCD: this.$t("coach.addNewSkill.data"),
      learningActionItems: false,
      constants,
      activeIndex: null,
      journeyQuests: {},
      activeStep: {},
      completedSteps: 0,
      journeyIndex: 1,
      galaQuests: false,
      questQ1: "",
      questQ2: "",
      appSteps,
    };
  },
  components: {
    VuePerfectScrollbar,
  },
  computed: {
    myOrganizations() {
  return this.$store.state.organization.myOrganizations;
},
    userOrganizations() { return this.$store.state.users.userOrganizations; },
    userData() { return this.$store.state.users.data; },
    userOrganization() { return this.$store.state.users.selectedOrganization; },
    notificationPanelPopup() { return this.$store.state.modals.notificationPanelPopup; },
    appSubscriptions() { return this.$store.state.users.appSubscriptions; },
    journeySteps() { return appSteps.flow.journey.steps; },
  },
  watch: {
    notificationType: {
      immediate: true,
      handler(newVal) {
        this.loadingSkeleton = true;
        if (newVal === "learning-actions") {
          this.fetchUserInterestedItems();
        } else if (newVal === "journey-quests") {
          this.getJourneyQuests();
        } else if (newVal === "growth-plans") {
          this.fetchGrowthPlans();
        } else if (newVal === "invites") {
          // Invites initialization logic goes here
          this.fetchInvitesData();
        }
      },
    },
    // ... items and notificationPanelPopup watchers (Unchanged) ...
    items: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          let claimItems = [];
          for (let i = 0; i < newVal.length; i++) {
            if (
              (newVal[i].reviewStatus && !newVal[i].tokenClaimed) ||
              (newVal[i].libraryItemValidationData &&
                (newVal[i].status === "done" ||
                  newVal[i].feedLibraryItemStatus === "done"))
            ) {
              this.learningActionItems = true;
            }

            if (
              ((newVal[i].reviewStatus &&
                newVal[i].reviewStatus.toLowerCase() === "accepted") ||
                newVal[i].feedItemUserValidationStatus) &&
              !newVal[i].tokenClaimed
            ) {
              claimItems.push(newVal[i]);
            }
            this.claimAllBtn = claimItems.length > 0 ? true : false;
          }
        }
      },
    },
    notificationPanelPopup: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (this.notificationType === "learning-actions") {
            this.fetchUserInterestedItems();
          }
        }
      },
    },
    userOrganizations: {
      handler(newVal) {
        for (let i = 0; i < newVal.length; i++) {
          this.galaQuests =
            newVal[i].organizationData.slug === "gala" ? true : false;
        }
      },
      deep: true,
      immediate: true,
    },
    appSubscriptions: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal.alex) {
          this.notificationType = "learning-actions";
        }
        else if (newVal.journey) {
          // this.notificationType = "journey-quests";
          // this.getJourneyQuests();
        }
        // Switched from growth-plans to invites as default fallback
        else {
          this.notificationType = "invites";
          this.loadingSkeleton = false;
        }
      },
    },
  },
  mounted() {
    if (this.appSubscriptions && this.appSubscriptions.alex) {
  this.notificationType = "learning-actions";
} else {
  this.notificationType = "invites"; // Changed from growth-plans
}
  },
  methods: {
    // ... all existing methods (mergeArrays, fetchUserInterestedItems, fetchGrowthPlans, etc.) remain untouched to preserve logic ...
    mergeArrays(array1, array2) {
      const merged = [];
      const idSet = new Set();
      if (array1.length > 0) {
        for (const item of array1) {
          merged.push(item);
          idSet.add(item.feedItemId);
        }
      }

      if (array2.length > 0) {
        for (const item of array2) {
          if (idSet.has(item.itemId)) {
            const existingItem = merged.find(
              (el) => el.feedItemId === item.itemId
            );
            Object.assign(existingItem, item);
          } else {
            merged.push(item);
            idSet.add(item.itemId);
          }
        }
      }

      for (let i = 0; i < merged.length; i++) {
        if (
          merged[i].libraryItemValidationData &&
          (merged[i].status === "done" ||
            merged[i].feedLibraryItemStatus === "done")
        ) {
          this.mergedItems.push(merged[i]);
        }
      }
    },
    fetchInvitesData() {
  const payload = {
    email: this.$store.state.auth.user.email,
    userId: this.$store.state.auth.user._id,
  };
  this.$store.dispatch("organization/fetchAllMyOrganizations", payload)
    .then(() => { this.loadingSkeleton = false; });
},
acceptAdminOrgInvite(adminId) {
  this.$store.dispatch("organization/acceptAdminOrgInvite", { adminId })
    .then(() => { window.location.href = "/user/my-organizations"; });
},
manageOrganization(idOrSlug) {
  window.location.href = `/organization/${idOrSlug}/dashboard`;
},

// Add created hook or update existing one
created() {
  this.fetchInvitesData();
},

// Add beforeCreate to ensure color theme matches
beforeCreate() {
  this.$store.commit("UPDATE_PRIMARY_COLOR", "#F2C244");
  this.$vs.theme({ primary: "#F2C244" });
},
    fetchUserInterestedItems() {
      if (this.notificationType === "learning-actions") {
        this.items = [];
        this.mergedItems = [];
        this.loadingSkeleton = true;
        this.$store
          .dispatch("alex/getRedirectItemsCount", {
            gtbrddUserId: this.$store.state.auth.user._id,
            source: ["LIBRARY"],
          })
          .then((res) => {
            if (res && res.data && res.data.length > 0) {
              let itemIds = [];
              let array1 = res.data;
              for (let element of res.data) {
                if (
                  element.libraryItemValidationData &&
                  element.feedItemId !== null
                ) {
                  if (!itemIds.includes(element.feedItemId)) {
                    itemIds.push(element.feedItemId);
                  }
                }
              }

              this.$store
                .dispatch("feed/fetchBulkItemDetails", {
                  itemId: itemIds,
                  getboardedId: this.$store.state.auth.user._id,
                })
                .then((res) => {
                  let array2 = [];
                  if (res && res.length > 0 && typeof res !== "string") {
                    array2 = res;
                    this.mergeArrays(array1, array2);
                    this.items = this.mergedItems;
                  } else {
                    this.mergeArrays(array1, array2);
                    this.items = this.mergedItems;
                  }
                })
                .catch((err) => {
                  this.mergeArrays(array1, []);
                  this.items = this.mergedItems;
                });

              if (res.data.length > 0) {
                this.loadingSkeleton = true;
                let fetchCustomLibraryItemPromises = [];

                for (let a = 0; a < res.data.length; a++) {
                  if (
                    res &&
                    res.data &&
                    res.data[a] &&
                    res.data[a].feedItemId &&
                    res.data[a].feedItemId.includes("altf")
                  ) {
                    const payload = {
                      orgId: "6512fc951aa789001abd5ed4",
                      itemId: res.data[a].feedItemId,
                      userId: this.$store.state.auth.user._id,
                    };
                    let item = res.data[a];
                    let promise = this.$store
                      .dispatch("alex/fetchCustomLibraryItem", payload)
                      .then((res) => {
                        if (
                          res.data &&
                          item.libraryItemValidationData &&
                          (res.data.status === "done" ||
                            res.data.feedLibraryItemStatus === "done")
                        ) {
                          this.items.push({ ...res.data, ...item });
                        }
                      })
                      .catch((err) => {
                        // Handle error
                      });
                    fetchCustomLibraryItemPromises.push(promise);
                  }
                }

                Promise.all(fetchCustomLibraryItemPromises)
                  .then(() => {
                    this.loadingSkeleton = false;
                  })
                  .catch((err) => {});
              } else {
                this.loadingSkeleton = false;
              }
            }
          })
          .catch((err) => {
            this.loadingSkeleton = false;
          });
      }
    },
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    openLink(item) {
      let link = `https://library.getboarded.com/redirect-page?itemId=${
        item.itemId
      }&type=${item.type || item.itemType}&gbuid=${this.userData._id}&gborgid=${
        this.userOrganization.organizationId
      }&redirectsourceid=USER_DASHBOARD`;
      if (link && !this.queries && !this.disableLink) {
        window.open(link, "_blank");
      }
    },
    validateItem(item) {
      event.stopPropagation();
      let itemData = [
        {
          id: item.itemId,
          slug: this.userOrganization.organizationData.slug,
          vType: item.libraryItemValidationData.validationType,
          token: this.$store.state.auth.accessToken,
          orgId: item.libraryItemValidationData.gtbrddOrganizationId,
        },
      ];
      this.$parent.itemData = itemData;
      this.$parent.activeAlex = true;
    },
    fetchGrowthPlans() {
      this.receivedCoachData = false;
      for (let i = 0; i < this.userOrganizations.length; i++) {
        this.$store
          .dispatch("users/getGrowthPlans", {
            userId: this.userData._id,
            orgId: this.userOrganizations[i].organizationId,
          })
          .then((res) => {
            if (res && res.data) {
              this.growthPlan = res.data;
            }
            if (res.code === "USER_IS_COACH") {
              return this.getCoachUserData();
            }
          })
          .catch((err) => {})
          .finally(() => {
            this.receivedCoachData = true;
            this.loadingSkeleton = false;
          });
      }
    },
    getJourneyQuests() {
      this.loadingSkeleton = true;
      this.$store
        .dispatch("users/fetchJourneyQuests", {
          gtbrddUserId: this.userData._id,
        })
        .then((res) => {
          this.journeyQuests = res.data;
          for (let key in res.data) {
            this.activeSelectedStep(res.data[key], key);
            break;
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loadingSkeleton = false;
        });
    },
    getCoachUserData() {
      this.$store
        .dispatch("coach/getCoachUserData", this.userData._id)
        .then((res) => {
          this.coachUserData = res;
        })
        .catch((err) => {})
        .finally(() => {
          this.receivedCoachData = true;

          setTimeout(() => {
            this.loadingSkeleton = false;
          }, 1000);
        });
    },
    toCoach() {
      let user = this.userData.email.slice(0, this.userData.email.indexOf("@"));
      window.location.href = `https://api.coach.getboarded.com/oauth/?selectedAccount=${user}`;
    },
    claimReward(item, index) {
      event.stopPropagation();

      if (!item.tokenClaimed) {
        const payload = {
          gtbrddOrganizationId:
            item.libraryItemValidationData.gtbrddOrganizationId,
          gtbrddUserId: this.userData._id,
          libraryItemId: item.itemId,
        };
        this.$store
          .dispatch("alex/claimRewards", payload)
          .then((res) => {
            if (res && res.data && res.data._id) {
              for (let i = 0; i < this.items.length; i++) {
                let itemsClaimedCount = 0;
                let itemsToBeClaimedCount = 0;
                if (this.items[i].tokenClaimed) {
                  itemsClaimedCount = itemsClaimedCount + 1;
                }

                if (this.items[i].reviewStatus) {
                  itemsToBeClaimedCount = itemsToBeClaimedCount + 1;
                }

                if (itemsClaimedCount === itemsToBeClaimedCount) {
                  this.claimAllBtn = false;
                }
              }

              this.activeIndex = index;

              setTimeout(() => {
                const ipGold = document
                  .getElementById(
                    `${item.libraryItemValidationData.gtbrddOrganizationId.slice(
                      -5
                    )}-reward-gold`
                  )
                  .getBoundingClientRect();

                this.$store.commit("animation/SET_INITIAL_POSITION_FOR_GOLD", {
                  top: ipGold.top,
                  bottom: ipGold.bottom,
                  left: ipGold.left,
                  right: ipGold.right,
                });

                const ipXp = document
                  .getElementById("reward-xp")
                  .getBoundingClientRect();

                this.$store.commit("animation/SET_INITIAL_POSITION_FOR_XP", {
                  top: ipXp.top,
                  bottom: ipXp.bottom,
                  left: ipXp.left,
                  right: ipXp.right,
                });
                this.$store.commit(
                  "animation/SET_GOLD_ID",
                  item.libraryItemValidationData.gtbrddOrganizationId.slice(-5)
                );
                this.$store.commit("animation/SET_ANIMATION_STATUS", true);
              }, 50);

              item.libraryItemValidationData.tokens.forEach((tokenObj) => {
                tokenObj["organizationId"] =
                  item.libraryItemValidationData.gtbrddOrganizationId;
              });
              this.$store.commit(
                "users/UPDATE_USER_TOKENS",
                item.libraryItemValidationData.tokens
              );
              this.items[index].tokenClaimed = true;
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      }
    },
    claimAllRewards() {
      for (let i = 0; i < this.items.length; i++) {
        if (
          this.items[i].reviewStatus ||
          this.items[i].feedItemUserValidationStatus
        ) {
          this.claimReward(this.items[i], i);
        }
      }
    },
    getCompentencyData(id) {
      const characteristicId = id.split("-")[0];
      const competencyId = id.split("-")[1];
      const competencies = this.CCD[characteristicId].competencies;
      return competencies[competencyId];
    },
    getTokenValue(tokens, key) {
      if (tokens) {
        let token = tokens.find((token) => token.key === key);
        return token ? token.value : 0;
      }
    },
    getJourneyProgress(steps) {
      let totalSteps = steps.length;
      let completedSteps = 0;
      for (let i = 0; i < steps.length; i++) {
        if (steps[i].completionPercentage === 100) {
          completedSteps = completedSteps + 1;
        }
      }
      return (100 * completedSteps) / totalSteps;
    },
    activeSelectedStep(journeyQuest, i) {
      this.activeStep = journeyQuest.steps;
      let completedSteps = 0;
      for (let i = 0; i < this.activeStep.length; i++) {
        if (this.activeStep[i].completionPercentage === 100) {
          completedSteps = completedSteps + 1;
        }
      }
      this.completedSteps = completedSteps;
      this.journeyIndex = i === "q1" ? 1 : 2;
    },
    getGoalActiveDate(quest) {
      let boardId =
        quest === "q1"
          ? "63f7ac7c99ee08001de8c9b0"
          : "64f48a69c433ae00195dbeb0";
      this.$store
        .dispatch("boards/fetchCurrentBoardUserDetails", {
          userId: this.userData._id,
          boardId: boardId,
        })
        .then((res) => {
          if (res && res.data && res.data[0] && res.data[0].createdAt) {
            const timestamp = new Date(res.data[0].createdAt);
            const day = timestamp.getDate();
            const monthNames = [
              "Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];
            const month = monthNames[timestamp.getMonth()];
            const year = timestamp.getFullYear();
            const formattedDate = `${day} ${month} ${year}`;
            if (quest === "q1") {
              this.questQ1 = formattedDate;
            } else if (quest === "q2") {
              this.questQ2 = formattedDate;
            }
          }
        })
        .catch((err) => {});
    },
    getStepName(stepId) {
      let step = this.journeySteps.find((step) => step.id === stepId);
      return step ? step.title : stepId;
    },
    skipValidation(item) {
      const payload = {
        gtbrddUserId: this.userData._id,
        gtbrddOrganizationId:
          item.libraryItemValidationData.gtbrddOrganizationId,
        feedItemId: item.itemId,
      };

      this.$store
        .dispatch("alex/skipItemValidation", payload)
        .then((res) => {
          if (res && res.data && res.data._id) {
            this.$refs.itemOptions[0].click();

            this.$vs.notify({
              title: "Validation skipped successfully !",
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success",
            });

            const tl = gsap.timeline({
              defaults: {
                duration: 0.5,
                ease: "rough",
                repeat: 0,
              },
            });
            tl.fromTo(
              "#" + item.itemId,
              0.5,
              { opacity: 1, display: "flex" },
              { opacity: 0, display: "flex" }
            );

            tl.fromTo(
              "#" + item.itemId,
              0.5,
              { opacity: 0, display: "none" },
              { opacity: 0, display: "none" }
            );
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.notification {
  &__container {
    z-index: 10;

    .notification-header {
      position: sticky;
      top: 0rem;
      z-index: 10;
      background: #fff;

      .types {
        margin: 0 -1em;
      }
    }

    .token-box {
      border-radius: 0.5rem;
      // background: #fff;
      background: #f2f4f7;
      border: 1px solid #d0d5dd;

      // box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25) inset,
      //   0px 4px 10px 0px rgba(0, 0, 0, 0.1);

      h6 {
        color: #676767 !important;
        text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
        font-weight: 500;
        right: 0;
        bottom: -10px;
      }
    }

    .btn {
      &-claim {
        background: #25cc9a1a;
        color: #25cc9a;

        &-all {
          background: #f2f4f7;
          color: #98a2b3;
        }
      }

      &-validate {
        background: #f8c62c;
        color: #fff;
      }
    }

    .claim-all-btn {
      background: #fff;
    }

    .heading {
      &-gray {
        color: #808080 !important;
      }
    }

    .border {
      border: 2px solid #efefef;
    }
  }

  &__inactive {
    h4 {
      color: #5e5b5b !important;
      font-weight: 400;
    }
  }

  &__active {
    h4 {
      color: #101828 !important;
      font-weight: 600;
    }
  }
}

.journey__notification__card {
  border-radius: 0.75rem;
  background: #7a5af8;

  .reward__container {
    border-radius: 0.375rem;
    background: rgba(255, 255, 255, 0.5);
  }

  .progress {
    width: 100%;
    -webkit-appearance: none;
    appearance: none;
    border-radius: 10px;
    border: 2px solid #fff;
    height: 15px;
    background-color: #fff;
    text-align: left;
  }

  /* For Chrome or Safari */
  progress::-webkit-progress-bar {
    background-color: #ffffff;
    border-radius: 10px;
  }

  progress::-webkit-progress-value {
    background-color: #25cc9a !important;
    border-radius: 10px;
    place-self: start;
  }

  /* For Firefox */

  progress::-moz-progress-bar {
    background-color: #25cc9a !important;
    border-radius: 10px;
  }
}

$bg: #fba62742;
$color: #fba727;

.icon-bg {
  background-color: $bg;
}

.skills-btn {
  color: $color !important;
  background: $bg;
}

.vx-card ::v-deep .vx-card__body {
  padding: 0;
}

.opacity {
  opacity: 0.075;
}

.webkit-width {
  width: -webkit-fill-available;
}

.circle ::v-deep .percent-text {
  font-size: 15px !important;
}

.stick-top {
  top: 6em;
}

.vs-con-table ::v-deep .vs-table--tbody-table {
  min-width: 100%;
}

.vs-con-table {
  width: 100%;
}

.add-btn {
  color: #fff;
  background: $color;
  border-radius: 5em;
}

.skeleton {
  background: #808080;
  animation: flicker-light 1s infinite alternate;
}

@keyframes flicker-light {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0.2;
  }
}

@media screen and (max-width: 991px) {
  .vs-con-table ::v-deep .vs-table--content {
    width: 100%;
  }
}

.ps ::v-deep .ps__scrollbar-y-rail {
  z-index: 100;
}

.progress__container {
  background-color: rgba(255, 215, 97, 0.3);
  width: 100%;
  min-height: 15rem;
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  gap: 2rem;
  align-items: center;
  text-align: left;

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 1.5rem;
    position: relative;

    img {
      width: 3rem;
      height: auto;
    }

    span {
      color: #ffb70c;
      // font-family: Poppins;
      font-size: 1rem;
      font-weight: 600;
      height: fit-content;
      position: absolute;
      margin-top: 5.5rem;
    }
  }

  &__bar {
    width: 100%;
    margin-right: 1.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    height: 10rem;
    position: relative;

    img {
      width: 2rem;
      place-self: start;
    }

    .odd {
      place-self: start;
    }

    .even {
      place-self: end;
    }

    .progress {
      width: 100%;
      -webkit-appearance: none;
      appearance: none;
      border: none;
      border-radius: 10px;
      height: 15px;
      background-color: #fcde98;
      place-self: center;
      position: absolute;
      text-align: left;
    }

    /* For Chrome or Safari */
    progress::-webkit-progress-bar {
      background-color: #fcde98;
      border-radius: 10px;
    }

    progress::-webkit-progress-value {
      background-color: #25cc9a !important;
      border-radius: 10px;
    }

    /* For Firefox */

    progress::-moz-progress-bar {
      background-color: #25cc9a !important;
      border-radius: 10px;
    }
  }
}

@media screen and (max-width: 530px) {
  .notification {
    &__container {
      left: 0;
      width: 100%;
    }
  }
}
</style>
